import axios from 'axios';
import { ElNotification } from 'element-plus'
import Bus from "./EventBus";
import router from '../router';
import Auth from "./auth";

async function RequestApi(Url, Method, Data, Type){
	let Token = Auth.getToken();

	let ReturnValue = '';

	if(Method == 'get'){
		await axios.get(Url, { params: Data, headers: { Authorization: "Bearer " + Token }, responseType: Type })
		.then(response => {
			// console.log(Data);
			// console.log(response);
			// console.log(response.data);
			// console.log(response.data.Data[0].DataId);
			ReturnValue = response.data;

			let tmpState = 0;
			if(Auth.getToken()){
				tmpState++;
			}

			//更新Token----------
			Auth.setToken(ReturnValue.Data[0].Token);
			//更新Token----------

			if(!Auth.getToken()){
				tmpState++;
			}
			
			if(tmpState >= 2){
				ElNotification({
					type: 'warning',
					title: "系统提示",
					message: "账号已退出",
					position: 'bottom-right',
					duration: 3000,
				})

				Bus.emit("onRefreshTopMemberInfo","Out");
			}
		})
		.catch(error => {
			// console.log(error);
			ReturnValue = error;
		});
	}
	if(Method == 'post'){
		await axios.post(Url, Data, { headers: { Authorization: "Bearer " + Token}, responseType: Type})
		.then(response => {
			// console.log(Data);
			// console.log(response);
			// console.log(response.data);
			// console.log(response.data.Data[0].DataId);
			ReturnValue = response.data;


			let tmpState = 0;
			if(Auth.getToken()){
				tmpState++;
			}

			//更新Token----------
			Auth.setToken(ReturnValue.Data[0].Token);
			//更新Token----------

			if(!Auth.getToken()){
				tmpState++;
			}

			if(tmpState >= 2){
				ElNotification({
					type: 'warning',
					title: "系统提示",
					message: "账号已退出",
					position: 'bottom-right',
					duration: 3000,
				})

				Bus.emit("onRefreshTopMemberInfo","Out");
			}

		})
		.catch(error => {
			// console.log(error);
			ReturnValue = error;
		});
	}

	return ReturnValue;
}

export default RequestApi;